// НАИМЕНОВАНИЯ ЗАПИСЕЙ В sessionStorage

/**
 * Список лент
 */
export const KEY_FEED_SESSION_STORAGE: string = '_sberlead_feed_';

/**
 * Список productId из события setProductsInBasket и/или setProductsInPages
 */
export const KEY_FEED_EVENT_PRODUCTS_SESSION_STORAGE: string = '_sberlead_feed_event_products_';

/**
 * Список categoryId из события setCategoryInPage
 */
export const KEY_FEED_EVENT_CATEGORIES_SESSION_STORAGE: string = '_sberlead_feed_event_categories_';

/**
 * Ключ для всех лент при работе скрипта feedSetSomeId
 */
export const KEY_FOR_ANY_FEED_EVENT_SESSION_STORAGE: string = '!_for_any_feed_!';
